export class UtilStorage {
  getCookie(name) {
    const re = new RegExp(`${name}=([^;]+)`);
    const value = re.exec(document.cookie);
    return value !== null ? decodeURI(value[1]) : null;
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; Secure`;
  }

  setCookie(name, value, days) {
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = '; expires=' + date.toGMTString();
      document.cookie = `${name}=${value}${expires}; path=/;Secure`;
    } else {
      const expires = '';
      document.cookie = `${name}=${value}${expires}; path=/;Secure`;
    }
  }
}
